import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { AUTH } from "@/constants/testIds";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const returnTo = loc.state?.returnTo || "/le-mie-prenotazioni";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Bentornato/a " + u.name);
      nav(u.role === "admin" ? "/admin" : returnTo);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore di accesso");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid md:grid-cols-2 bg-craft">
      <div className="hidden md:flex flex-col justify-between p-12 bg-foreground text-background">
        <div className="font-display text-2xl">Maurizi</div>
        <div>
          <div className="text-xs tracking-widest uppercase text-primary">Area clienti</div>
          <h1 className="font-display text-4xl mt-3 leading-tight text-background">Le tue prenotazioni,<br/><span className="italic text-primary">a portata di mano</span>.</h1>
          <p className="text-background/70 mt-4 max-w-sm">Accedi per vedere le tue richieste, ricevere aggiornamenti sugli interventi e fissare nuovi appuntamenti.</p>
        </div>
        <div className="text-xs text-background/50">parquet · scale · ringhiere · infissi</div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <form onSubmit={submit} className="w-full max-w-md bg-white border border-border rounded-xl p-8 shadow-sm">
          <div className="font-display text-3xl">Accedi</div>
          <div className="text-sm text-foreground/60 mt-1">Bentornato/a. Inserisci le tue credenziali.</div>

          <Button type="button" variant="outline" className="w-full mt-6 rounded-full h-11" onClick={startGoogleLogin} data-testid={AUTH.googleBtn}>
            <svg className="h-4 w-4 mr-2" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.9-5.5 3.9-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.9 3.5 14.7 2.5 12 2.5 6.7 2.5 2.5 6.7 2.5 12s4.2 9.5 9.5 9.5c5.5 0 9.1-3.9 9.1-9.3 0-.6-.1-1.1-.2-1.5H12z"/></svg>
            Continua con Google
          </Button>

          <div className="flex items-center gap-3 my-6">
            <div className="flex-1 h-px bg-border" />
            <div className="text-xs text-foreground/50 uppercase tracking-widest">oppure</div>
            <div className="flex-1 h-px bg-border" />
          </div>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid={AUTH.emailInput} className="mt-1" />
            </div>
            <div>
              <Label htmlFor="pw">Password</Label>
              <Input id="pw" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} data-testid={AUTH.passwordInput} className="mt-1" />
            </div>
          </div>

          <Button type="submit" disabled={busy} className="w-full mt-6 rounded-full h-11" data-testid={AUTH.submitBtn}>
            {busy ? "Attendere..." : "Accedi"}
          </Button>

          <div className="text-sm text-center mt-3">
            <Link to="/password-dimenticata" className="text-foreground/60 hover:text-primary" data-testid="auth-forgot-link">Password dimenticata?</Link>
          </div>

          <div className="text-sm text-center text-foreground/60 mt-5">
            Non hai un account?{" "}
            <Link to="/registrati" className="text-primary font-semibold" data-testid={AUTH.switchMode}>Registrati</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
